





























































































































































































































































































































































































































































































































































import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import Modal from "@/components/shared/modal/Modal.vue";
import i18n from "@/lang/i18n";
import {
  ClaimDTO,
  ClaimCategorizationDTO,
  ClaimMessageDTO,
  CourierServiceDTO,
  IncidentDTO,
  IncidentAttachmentDTO
} from "@/model/data.model";
import { ClaimService } from "@/services/ClaimService";
import { isUk, notifyErrorReason } from "@/services/Helpers";
import cloneDeep from "lodash/cloneDeep";
import * as moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: { DecimalNumber, MbeModal: Modal }
})
export default class IncidentDetails extends Vue {
  countries: any[] = [];
  subCountriesFrom: any[] = [];
  subCountriesTo: any[] = [];
  courierServices: CourierServiceDTO[] = [];
  categorizations: ClaimCategorizationDTO[] = [];
  categorization = "";
  description = "";
  hideCourierId = true;
  hideCourierServiceId = true;
  hideCourierTracking = true;

  showEditMessageModal = false;
  savingEditMessage = false;
  editMessageOriginalText = "";
  editMessageText = "";
  editingMessage: any = null;

  model: IncidentDTO = {
    shipmentId: "",
    customerName: "",
    customerId: 0,
    shipmentSource: "",
    id: "",
    tenantId: 0,
    shipmentType: null,
    storeId: 0,
    multistoreId: 0,
    courierName: "",
    courierId: 0,
    courierServiceId: 0,
    courierServiceName: "",
    courierTracking: "",
    mbeServiceId: 0,
    mbeServiceName: "",
    mbeTracking: "",
    shipmentDate: "",
    receiverEmail: null,
    countryFrom: "",
    subcountryFrom: "",
    countryTo: "",
    incidentAttachments: [],
    subcountryTo: "",
    insurance: false,
    safeValue: false,
    safeValue4Business: false,
    safeValueType: "",
    active: false,
    creationDate: "",
    lastUpdateDate: "",
    messages: [],
    claim: {
      assigneeName: "",
      assigneeId: 0,
      dueDate: "",
      claimStatus: "",
      description: "",
      priority: "",
      categorization: "",
      errorType: "",
      errorSubtype: "",
      notes: [],
      protocolNumber: null
    } as ClaimDTO,
    incidentProformaValue: null,
    incidentShipmentCost: null,
    incidentSource: ""
  };

  attachmentsList: any[] = [];

  newMessageText = "";
  sendingMessage = false;

  get incidentId() {
    return this.$route.params.id || "";
  }

  get isActive() {
    return this.model.active;
  }

  get currentUsername(): string {
    return this.$store.getters.username ? this.$store.getters.username : "";
  }

  get isEditMessageChanged(): boolean {
    const a = (this.editMessageOriginalText || "").trim();
    const b = (this.editMessageText || "").trim();
    return a !== b;
  }

  async saveIncidentData() {
    try {
      const model = await ClaimService.prototype.updateIncidentInfo(
        this.model.id,
        { description: this.description, categorization: this.categorization }
      );
      Object.assign(this.model, cloneDeep(model));
      this.categorization = this.model.claimDraft.categorization;
      this.description = this.model.claimDraft.description;
      this.$alerts.success(i18n.t("success"));
    } catch (err) {
      await notifyErrorReason(err, this);
    }
  }

  async loadIncidentData() {
    const model = await ClaimService.prototype.getIncidentData(this.incidentId);
    Object.assign(this.model, cloneDeep(model));

    const msgs: any[] = (this.model as any).messages;
    if (Array.isArray(msgs)) {
      msgs.sort((a: any, b: any) =>
        String(b.creationDate).localeCompare(String(a.creationDate))
      );
    }

    await this.loadCategorization();
  }

  get allowAttachmentDelete() {
    return (item: IncidentAttachmentDTO) => {
      return item.source !== "MBE_HUB";
    };
  }

  get getDeleteBtnDisableTooltipText() {
    return (item: IncidentAttachmentDTO) => {
      if (!this.isActive)
        return this.$i18n.t("CLAIM_INCIDENT_ATTACHMENT_DELETE_INACTIVE_TEXT");
      if (!this.allowAttachmentDelete(item))
        return this.$i18n.t(
          "CLAIM_INCIDENT_ATTACHMENT_DELETE_UPLOADED_BY_CENTER"
        );
      return "";
    };
  }

  async loadCategorization() {
    if (!this.model.claim) {
      try {
        this.categorizations = await ClaimService.getClaimCategorization();
        this.categorization = this.model.claimDraft.categorization;
        this.description = this.model.claimDraft.description;
      } catch (err) {
        console.error(err);
      }
    } else {
      this.categorizations = [
        { description: this.model.claim.categorization }
      ] as ClaimCategorizationDTO[];
      this.categorization = this.model.claim.categorization;
      this.description = this.model.claim.description;
    }
  }

  async showAttachment(item: IncidentAttachmentDTO) {
    try {
      const urls = await ClaimService.prototype.getClaimAttachmentList(
        this.incidentId,
        [item.path]
      );
      if (urls && urls.length > 0) {
        const a: any = document.createElement("A");
        a.href = urls[0];
        a.setAttribute("target", "_blank");
        a.download = item.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (err) {
      await notifyErrorReason(err, this);
    }
  }

  isFormatCorrect(file: File): boolean {
    const extensions: string[] = ["application/pdf"];
    return extensions.includes(file.type);
  }

  async addAttachment(data: any) {
    if (!this.isFormatCorrect(data.file)) {
      this.$notify.error(i18n.t("invalid_filetype"));
      return;
    }

    const attachmentFile = new File([data.file], data.file.name, {
      type: data.file.type
    });
    const formData = new FormData();
    formData.append("files", attachmentFile);

    try {
      this.model = await ClaimService.prototype.uploadAttachment(
        formData,
        this.incidentId
      );
    } catch (err) {
      await notifyErrorReason(err, this);
    }
  }

  confirmDeleteAttachment(item: IncidentAttachmentDTO) {
    this.$alerts.confirm(this.$t("confirm_delete_attachment")).then(res => {
      if (res) {
        this.deleteAttachment(item);
      }
    });
  }

  async deleteAttachment(item: IncidentAttachmentDTO) {
    try {
      await ClaimService.prototype.deleteAttachments(this.incidentId, [
        item.path
      ]);
      await this.loadIncidentData();
    } catch (err) {
      await notifyErrorReason(err, this);
    }
  }

  async created() {
    try {
      await this.loadIncidentData();
    } catch (err) {
      console.error(err);
    }
  }

  isExtraserviceActive(id: number) {
    const extraservices = this.$store.getters["customer/extraServiceConfig"];
    return extraservices.some(e => e.extraServiceId === id && e.active);
  }

  async sendMessage() {
    const text = (this.newMessageText || "").trim();
    if (!text) return;

    this.sendingMessage = true;

    try {
      await ClaimService.prototype.createClaimMessage(
        this.model.id,
        this.newMessageText
      );
      await this.loadIncidentData();
      this.newMessageText = "";
    } catch (err) {
      await notifyErrorReason(err, this);
    } finally {
      this.sendingMessage = false;
    }
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY");
  }

  formatLocalDateTime(value: any) {
    return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
  }

  editMessage(item: any) {
    if (this.currentUsername !== item.username) return;

    const original = item && item.text ? String(item.text) : "";

    this.editingMessage = item;
    this.editMessageOriginalText = original;
    this.editMessageText = original;

    this.showEditMessageModal = true;
  }

  closeEditMessageModal() {
    this.showEditMessageModal = false;
    this.editingMessage = null;
    this.editMessageOriginalText = "";
    this.editMessageText = "";
  }

  async saveEditedMessage() {
    if (!this.editingMessage || !this.isEditMessageChanged) return;

    const text = (this.editMessageText || "").trim();
    if (!text) return;

    this.savingEditMessage = true;

    try {
      const data = {
        messageId: this.editingMessage.messageId,
        text
      };

      await ClaimService.prototype.updateClaimMessage(
        data as ClaimMessageDTO,
        this.incidentId
      );
      await this.loadIncidentData();
      this.closeEditMessageModal();
    } catch (err) {
      await notifyErrorReason(err, this);
    } finally {
      this.savingEditMessage = false;
    }
  }

  async deleteMessage(item: any) {
    if (this.currentUsername !== item.username) return;

    try {
      const resp = await this.$alerts.confirm(
        this.$i18n.t("CLAIM_DELETE_MESSAGE_MODAL_TITLE")
      );
      if (!resp) return;

      await ClaimService.prototype.deleteClaimMessage(
        item.messageId,
        this.incidentId
      );
      await this.loadIncidentData();
    } catch (err) {
      await notifyErrorReason(err, this);
    }
  }

  get draftEditDisabled() {
    if (this.model.incidentSource === "MBE_ONLINE") {
      return this.model.claim !== null;
    }
    return true;
  }

  get saveButtonVisible() {
    if (this.model.incidentSource !== "MBE_ONLINE") return false;
    return (
      this.categorization !== this.model.claimDraft.categorization ||
      this.description !== this.model.claimDraft.description
    );
  }

  get claimMessages() {
    const msgs: any[] = (this.model as any).messages;
    if (!Array.isArray(msgs)) return [];
    return msgs;
  }

  get isUk() {
    return isUk();
  }
}
